module.exports = __webpack_public_path__ + "img/user-profile.c90dfdbc.svg";